import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import CategoryPageLayout from '@/components/pages/category/layout/category-page-layout';
import { ArticleType } from '@/types/article-type';
import { Category } from '@/utils/functions/wordpress/fetch-categories';

export interface CategoryPageControllerProps {
    articles: ArticleType[];
    category: Category;
    pageLimit: number;
}

const CategoryPageController = ({ category, articles, pageLimit }: CategoryPageControllerProps) => {
    return <CategoryPageLayout key={category.slug} pageLimit={pageLimit} articles={articles} category={category} />;
};

export default withExceptionCatcher(CategoryPageController);
